import React from 'react';

function implinks(){
    return(
        <div className = "books">
        <h1 id="title">IMP LINKS</h1>
<nav id="tree-list">
            
        <h2 className="Header-titles" data-aos="fade-up" >YouTube Channels</h2>
    <ul className="container">
        <li>
            <h3 data-aos="flip-left">Engg. Mathematics</h3>
            <ul className="tree-down"  data-aos="fade-up">
                <li>Mathematics Complete<a href="https://www.youtube.com/channel/UCBmdoqkBaIUh128ffq8XATw"><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/YouTube_social_white_squircle_%282017%29.svg/1024px-YouTube_social_white_squircle_%282017%29.svg.png" alt="YouTube"/></a></li>
                <li>Mathematics for extra topics<a href="https://www.youtube.com/channel/UC_4NoVAkQzeSaxCgm-to25A"><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/YouTube_social_white_squircle_%282017%29.svg/1024px-YouTube_social_white_squircle_%282017%29.svg.png" alt="YouTube"/></a></li>
            </ul>
        </li>
        <li>
            <h3 data-aos="flip-left">Engg. Physics</h3>
            <ul className="tree-down"  data-aos="fade-up">
                <li>Quantum Physics<a href="https://www.youtube.com/watch?v=3BXTHiAVad4&list=PLhkDqXgbPxxFhFY_X2EmS_nQBtti1aAKw"><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/YouTube_social_white_squircle_%282017%29.svg/1024px-YouTube_social_white_squircle_%282017%29.svg.png" alt="Download"/></a></li>
                <li>Classical Mechanics<a href="https://www.youtube.com/playlist?list=PLX2gX-ftPVXX6ctceuUBuClP83K5wJtGt"><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/YouTube_social_white_squircle_%282017%29.svg/1024px-YouTube_social_white_squircle_%282017%29.svg.png" alt="Download"/></a></li>
                <li>Radiation Laws<a href="https://www.youtube.com/channel/UCw13t2bffURH4ulluGusjxQ/feed"><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/YouTube_social_white_squircle_%282017%29.svg/1024px-YouTube_social_white_squircle_%282017%29.svg.png" alt="Download"/></a></li>
            </ul>
        </li>
        <li>
            <h3 data-aos="flip-left">Basic Elctronics</h3>
            <ul className="tree-down"  data-aos="fade-up">
                <li>Complete Electronics<a href="https://www.youtube.com/user/nesoacademy"><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/YouTube_social_white_squircle_%282017%29.svg/1024px-YouTube_social_white_squircle_%282017%29.svg.png" alt="Download"/></a> </li>
            </ul>
        </li>
        <h2 className="Header-titles" data-aos="fade-up">You should know!</h2>
        <li>
            <h3 data-aos="flip-left">Useful Websites</h3>
            <ul id="tree-down"  data-aos="fade-up">
                <li><a href="https://stackoverflow.com/">Stack Overflow</a></li>
                <li><a href="https://www.codechef.com/certification/data-structures-and-algorithms/about?ref=hpbanner">Data Structures</a></li>
                <li><a href="https://www.w3schools.com/">W3Schools</a></li>
                <li><a href="https://www.circuito.io/">Circuit Designing</a></li>
                <li><a href="https://www.geeksforgeeks.org/">Geeks for Geeks</a></li>
                <li><a href="https://github.com/">GitHub</a></li>
                <li><a href="https://www.npmjs.com/">Best Open Source Packages</a></li>
                <li><a href="http://gen.lib.rus.ec">For free PDFs</a></li>
                
            </ul>
        </li>
        <li>
            <h3 data-aos="flip-left">Freshmen Guide</h3>
            <ul className="tree-down"  data-aos="fade-up">
                <li>WordPress Link<a href="https://nithfreshmenguide.wordpress.com/"><img src="https://images.vexels.com/media/users/3/157545/isolated/preview/057098b4a63e172134e0f04bbbcd6e8b-school-book-icon-by-vexels.png"/></a></li>
            </ul>
        </li>
        </ul>
</nav>
</div>
    )
}

export default implinks;